export class ProductTabDetails {
  id: string;
  name: string;
  description: string;
  status: number;
  resourceVersion: string;
  channel: number;
}
